import {Component, Input} from '@angular/core';
import {AbstractFieldComponent} from '../_abstract/abstract-field.component';

@Component({
    selector: 'field-select',
    templateUrl: './field-select.component.html',
    styleUrls: [
        './field-select.component.scss'
    ],
    standalone: false
})
export class FieldSelectComponent extends AbstractFieldComponent {

  @Input() public caption = '';
  @Input() public multiple = false;

}
